<app-loading *ngIf="contentReady"></app-loading>

<div [class.font-100]="receipt" class="invoice-container" [class.scale]="receipt" style="direction: rtl;">
  <div class="invoice-header">
    <!-- زر الطباعة العادية -->
    <button onclick="window.print();" class="noPrint printbtn btn btn-primary">{{ 'اطبع' | transloco }}</button>


    <img [class.img-101]="receipt" [defaultImage]="'/assets/loading-in.gif'" [lazyLoad]="userimage"
      [errorImage]="'/assets/logo-01.png'" [alt]="'product' | transloco" />

    <h1 [class.font-101]="receipt">{{ 'الفاتورة' | transloco }}</h1>
    <p [class.font-100]="receipt">{{ 'رقم الفاتورة: #' | transloco }}{{invoiceId}}</p>
    <p [class.font-100]="receipt">{{ 'التاريخ:' | transloco }} {{date}}</p>
  </div>

  <div class="invoice-details row">
    <div class="col-sm-12 col-md-6" [class.width-100]="receipt">
      <h3 [class.font-101]="receipt">{{ 'من:' | transloco }}</h3>
      <p [class.font-100]="receipt">{{pagename}}</p>
      <p [class.font-100]="receipt">{{userphone}}</p>
      <p [class.font-100]="receipt">{{facebook}}</p>
      <p [class.font-100]="receipt">{{instagram}}</p>
      <p [class.font-100]="receipt">{{tiktok}}</p>
    </div>
    <div class="col-sm-12 col-md-6" [class.width-100]="receipt">
      <h3 [class.font-101]="receipt">{{ 'الي:' | transloco }}</h3>
      <p [class.font-100]="receipt">{{clientname}}</p>
      <p [class.font-100]="receipt">{{firstphone}}</p>
      <p [class.font-100]="receipt">{{secphone}}</p>
      <p [class.font-100]="receipt">{{ grov?.governorate_name_ar }}-{{ city?.city_name_ar }}</p>

      <p [class.font-100]="receipt">{{address}}</p>
      <p class="noPrint"><span style="color: red;">{{ 'ملحوظة:' | transloco }}</span> {{note}}</p>
      @if(delivery_hero != null){
      <p class="noPrint"><span>{{ 'مندوب الشحن:' | transloco }} {{delivery_hero}}</span></p>
      }
    </div>
  </div>

  @if(receipt){
  <!-- ✅ Products List -->
  <div class="invoice-list">
    <div class="list-header">
      <div>{{ 'المنتج' | transloco }}</div>
      <div>{{ 'الكمية' | transloco }}</div>
      <div>{{ 'الوحده' | transloco }}</div>
      <div>{{ 'الاجمالي' | transloco }}</div>
    </div>

    <div class="list-body">
      <div class="list-row" *ngFor="let product of products; let i = index">
        <div>{{products[i]}}</div>
        <div>{{qty[i]}}

        </div>
        <div>{{prices[i]}} {{ 'جنيه مصري' | transloco }} </div>
        <div>{{prices[i] * qty[i]}} {{ 'جنيه مصري' | transloco }}</div>
      </div>
    </div>

    <div class="list-footer">
      <div class="footer-row">
        <div>{{ 'المجموع الفرعي' | transloco }}</div>
        <div>{{sumprices}} {{ 'جنيه مصري' | transloco }}</div>
      </div>
      <div class="footer-row">
        <div>{{ 'سعر التوصيل' | transloco }}</div>
        <div>{{deliveryfees}} {{ 'جنيه مصري' | transloco }}</div>
      </div>
      <div class="footer-row">
        <div>{{ 'خصم' | transloco }}</div>
        <div>{{discount}} {{ 'جنيه مصري' | transloco }}</div>
      </div>
      <div class="footer-row total">
        <div>{{ 'الاجمالي' | transloco }}</div>
        <div>{{sumprices + deliveryfees - discount}} {{ 'جنيه مصري' | transloco }}</div>
      </div>
    </div>
  </div>
  }
  @else{
  <table class="invoice-table">
    <thead [class.thead]="receipt">
      <tr>
        <th [class.font-101]="receipt">{{ 'المنتج' | transloco }}</th>
        <th [class.font-101]="receipt">{{ 'الكمية' | transloco }}</th>
        <th [class.font-101]="receipt">{{ 'الوحده' | transloco }}</th>
        <th [class.font-101]="receipt">{{ 'الاجمالي' | transloco }}</th>
      </tr>
    </thead>
    <tbody [class.tbody]="receipt">
      <tr *ngFor="let product of products; let i = index">
        <td [class.font-100]="receipt">{{products[i]}}</td>
        <td [class.font-100]="receipt">{{qty[i]}}
        </td>
        <td [class.font-100]="receipt">{{prices[i]}} {{ 'جنيه مصري' | transloco }}</td>
        <td [class.font-100]="receipt">{{prices[i] * qty[i]}} {{ 'جنيه مصري' | transloco }}</td>
      </tr>
    </tbody>
    <tfoot [class.tfoot]="receipt">
      <tr>
        <td colspan="3" [class.font-101]="receipt">{{ 'المجموع الفرعي' | transloco }}</td>
        <td [class.font-100]="receipt">{{this.sumprices}} {{ 'جنيه مصري' | transloco }}</td>
      </tr>
      <tr>
        <td colspan="3" [class.font-101]="receipt">{{ 'سعر التوصيل' | transloco }}</td>
        <td [class.font-100]="receipt">{{deliveryfees}} {{ 'جنيه مصري' | transloco }}</td>
      </tr>
      <tr class="total">
        <td colspan="3" [class.font-101]="receipt">{{ 'الخصم' | transloco }}</td>
        <td [class.font-100]="receipt">{{discount}} {{ 'جنيه مصري' | transloco }}</td>
      </tr>
      <tr>
        <td colspan="3" [class.font-101]="receipt">{{ 'الاجمالي' | transloco }}</td>
        <td [class.font-100]="receipt">{{this.sumprices + deliveryfees - discount}} {{ 'جنيه مصري' | transloco }}</td>
      </tr>
    </tfoot>
  </table>
  }


  <div class="invoice-footer">

    <p>{{ 'شكرا لاختيارك' | transloco }} {{pagename}}!</p>
  </div>
</div>